import Concept from './Concept'
import Business from './Business'
import Company from './Company'
import Contact from './Contact'

export default {
  spConcept: Concept,
  spBusiness: Business,
  spCompany: Company,
  spContact: Contact
}
